interface KisAgentSpec {
  inTranCode: string;
  inTradeType: string;
  inInstallment: string;
  inTranAmt: string;
}

export const makeKisPaymentSpec = (amount: number): string => {
  const agentSpec: KisAgentSpec = {
    inTranCode: 'NV',
    inTradeType: 'D1',
    inInstallment: '00',
    inTranAmt: amount.toString(),
  };

  return JSON.stringify({
    KIS_ICApproval: agentSpec,
  });
};
